import type { DestinationOption } from "./types";

// Slack destinations are no longer hardcoded here — SendNowForm fetches the
// real channel list via useSlackConnection()/listSlackChannels() once the
// workspace's Slack connection is live.

export const TEAMS_OPTIONS: DestinationOption[] = [
  { value: "Sales team", label: "Sales team", kind: "team" },
  { value: "Marketing team", label: "Marketing team", kind: "team" },
  { value: "Product team", label: "Product team", kind: "team" },
  { value: "Leadership", label: "Leadership", kind: "team" },
  { value: "John Doe", label: "John Doe", kind: "user" },
  { value: "Sarah Chen", label: "Sarah Chen", kind: "user" },
  { value: "Mike Ross", label: "Mike Ross", kind: "user" },
];

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
